import React from 'react';
import PropTypes from 'prop-types';

const ViewportWarningIcon = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 500"
        width="100%"
        height="100%"
        className={className}
        aria-hidden="true"
        focusable="false"
    >
        <path
            d="M 263 118 Q 250 95 237 118 L 94 366 Q 80 390 104 390 L 396 390 Q 420 390 406 366 Z"
            fill="#f2c602"
            stroke="#f2c602"
            strokeWidth="55"
            strokeLinejoin="round"
        />
        <line
            x1="250"
            y1="195"
            x2="250"
            y2="285"
            stroke="#050714"
            strokeWidth="32"
            strokeLinecap="round"
        />
        <circle cx="250" cy="345" r="16" fill="#050714" />
    </svg>
);

ViewportWarningIcon.propTypes = {
    className: PropTypes.string,
};

ViewportWarningIcon.defaultProps = {
    className: '',
};

export default ViewportWarningIcon;
